import { render } from "./cardPwdModify.vue?vue&type=template&id=8151f20a"
import script from "./cardPwdModify.vue?vue&type=script&lang=js"
export * from "./cardPwdModify.vue?vue&type=script&lang=js"

import "./cardPwdModify.vue?vue&type=style&index=0&id=8151f20a&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__